import { Component, EventEmitter, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { MarketDoc, MarketService } from '../market.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentService } from 'src/app/documents/documents.service';
import { MessageLevel, PgMessagesService } from 'src/app/shared/services/pg-messages.service';
import { saveAs } from 'file-saver';
import { DateTimeHelpers } from 'src/app/shared/helpers/date-time.helpers';
import { PgDateRangeTitleEnum, PgTitleComponent } from 'src/app/shared/components/title-bar/title-bar.component';
import { MarketToolbarComponent } from '../market-toolbar/market-toolbar.component';
import moment from 'moment';
import { DateRange } from 'src/app/shared/components/date-range.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';

@Component({
  selector: 'app-market-files',
  templateUrl: './market-files.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, AgGridModule],
})
export class MarketFilesComponent implements OnInit, PgTitleComponent {

  toolbarComponentType = MarketToolbarComponent;
  toolbarComponent!: MarketToolbarComponent;

  dateRange: DateRange = {
    startDate: new Date(),
    endDate: new Date()
  };

  marketDocs: MarketDoc[] = [];
  title = new EventEmitter<string>();
  dateRangeSubTitle = new EventEmitter<[DateRange, PgDateRangeTitleEnum]>();

  gridOptions: GridOptions = {};

  constructor(private pricingService: MarketService,
    private activatedRoute: ActivatedRoute,
    private documentService: DocumentService,
    private messageService: PgMessagesService,
    private _router: Router,
    private _renderer: Renderer2
  ) { }

  columnDefs = [
    { headerName: 'Publisher', field: 'publisher', },
    { headerName: 'File Name', field: 'fileName', },
    {
      headerName: 'Date', field: 'timestamp',
      sort: 'desc',
      cellRenderer: (row: any) => DateTimeHelpers.formatUTCDate(row.data.timestamp),
    },
    {
      headerName: 'download',
      cellRenderer: (row: any) =>
        AgGridService.downloadButton(
          this._renderer,
          () => this.downloadFile(row.data.docId, row.data.fileName),
        )
    }
  ];

  ngOnInit(): void {
    this.gridOptions = AgGridService.getOptions();
    this.activatedRoute.queryParams.subscribe(prarams => {
      this.title.emit('Prices Documents');
      const startDate = prarams['startTime'] ? +prarams['startTime'] : moment().subtract(1, 'year').toDate().getTime();
      const endDate = prarams['endTime'] ? +prarams['endTime'] : new Date().getTime();
      this.dateRange = {
        startDate: new Date(startDate),
        endDate: new Date(endDate)
      };
      this.toolbarComponent.dateRange = this.dateRange;
      this.pricingService.getPublisherDocs(startDate, endDate).subscribe(docs => {
        this.marketDocs = docs;
      });
    });
    this.toolbarComponent.date.subscribe(dateRange => {
      this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this._router
          .navigate(['pricing/files/'], {
            queryParams: {
              startTime: dateRange?.startDate.getTime(),
              endTime: dateRange?.endDate.getTime()
            }
          })
          .then((e) => console.log(`Result of Navigation is ${e}`));
      });
    });
    this.dateRangeSubTitle.emit([
      this.dateRange,
      PgDateRangeTitleEnum.defaultTitle,
    ]);
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  downloadFile(fileId: string, prefix: string) {
    this.documentService.download(fileId).subscribe(b => {
      saveAs(b.body, prefix);
    }, () => {
      this.messageService.publishMessage({
        message: 'Could not download this file.',
        level: MessageLevel.Error,
        topic: 'Market document'
      });
    });
  }
}
